import React from 'react';
import { FormattedMessage } from "react-intl";
import {Space} from 'antd';
import './styles.scss';

interface SortingSwitchProps {
    filtersSelected: any,
    setFiltersSelected: React.Dispatch<React.SetStateAction<any>>,
    setReload: React.Dispatch<React.SetStateAction<boolean>>,
}

const options = {
    asc: 'general.sort_az',
    desc: 'general.sort_za',
};

const Index: React.FC<SortingSwitchProps> = ({
    filtersSelected,
    setFiltersSelected,
    setReload
}) => {
    const selectedKey: keyof typeof options = filtersSelected.sorting === 'desc' ? 'desc' : 'asc';
    const selectedSorting = options[selectedKey];

    const toggleSorting = () => {
        const nextKey = selectedKey === 'asc' ? 'desc' : 'asc';
        setFiltersSelected((filtersSelected: any) => ({
            ...filtersSelected,
            sorting: nextKey
        }));
        setReload(true);
    };

    return (
        <button
            type='button'
            className='sorting-switch'
            onClick={toggleSorting}
        >
            <Space size={4}>
                <FormattedMessage id={selectedSorting} />
                <i className={`fa-light ${selectedKey === 'asc' ? 'fa-arrow-down' : 'fa-arrow-up'}`} />
            </Space>
        </button>
    );
}

export default Index;
